import { OnInit } from "@angular/core";
var InputComponent = /** @class */ (function () {
    function InputComponent() {
    }
    InputComponent.prototype.ngOnInit = function () { };
    return InputComponent;
}());
export { InputComponent };
